<template>
  <v-img
    contain
    max-width="160"
    :width="`${withImg ? withImg : '90'}px`"
    :src="baseImg"
  >
  <v-layout
    fill-height
    align-center
    justify-center
    v-if="loadingdir"
  >
    <v-progress-circular
      indeterminate
      color="accent"
      :width="2"
      :size="40"
    ></v-progress-circular>
  </v-layout>
    
  </v-img>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      baseImg: "",
      loadingdir: false,
      updateImg: Math.floor(Math.random() * 100),
    };
  },
  methods: {
    setBaseImg(val) {
      this.baseImg = val;
      this.loadingdir = false;
    },
    async getBase64FromUrl(url) {
      this.loadingdir = true;
      const data = await fetch(url);
      const blob = await data.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data);
        };
      });
    },
    ChrEsp(chr) {
      const chrSplit = chr.split("");
      let newChr = "";

      chrSplit.forEach((x) => {
        if (x === "/") newChr += "-";
        else if (x === ".") newChr += "-";
        else newChr += x;
      });

      return newChr;
    },
  },

  created() {
    this.getBase64FromUrl(this.urlimg).then(
      (value) => this.setBaseImg(value),
      (reason) => console.log(reason)
    );
  },
  computed: {
    ...mapState([
      "imgPeque",
      "imgPequeP",
      "imgPequeP2",
      "dataUser",
      "Leerdir",
      "dirPHP",
      "domoapi2_img",
    ]),
    imgSrc() {      
      let xSrc = this.domoapi2_img;
      xSrc += "Articulo/";
      xSrc += this.ChrEsp(this.codart);
      xSrc += "/Principal?";
      xSrc += "i=" + this.updateImg;
      xSrc += "&Cia=15";
      return xSrc;
    },
  },
  props: {
    codart: String,
    withImg: Number,
    urlimg: String,
  },
};
</script>

<style scoped>
.img_art {
  width: auto;
  height: 50%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
